import makeAnimated from 'react-select/animated';
import useLoadForm from './functions/useLoadForm';
import useInputChanges from './functions/useInputChanges';
import useFormSubmit from './functions/useFormSubmit';

interface UseVehicleFormInterface {
  edit: boolean;
}

export default function useVehicleForm({ edit }: UseVehicleFormInterface) {
  const animatedComponents = makeAnimated();

  const {
    setIsSelectLoading,
    setIsLinesSelectLoading,
    setAffreightmentLines,
    setWorkplace,
    setModel,
    setTransportType,
    setTransportTypeValue,
    setVehicleCode,
    setBrand,
    setCapacity,
    setConsumption,
    setIsLinesSelectDisabled,
    model,
    transportType,
    transportTypeValue,
    vehicleCode,
    brand,
    capacity,
    consumption,
    workplace,
    affreightmentLines,
    isSelectLoading,
    isLinesSelectLoading,
    isLinesSelectDisabled,
    getErrorMessageByFieldName,
    handleModelChange,
    handleVehicleCodeChange,
    handleBrandChange,
    handleCapacityChange,
    handleConsumptionChange,
    handleLocTrabChange,
    handleLinesChange,
    errors,
    linesOptions,
    getLinesOfWorkplace,
  } = useInputChanges();

  const {
    apiVehicleFetched,
    apiWorkplaceFetched,
    doesListWorkplacesExists,
    workplacesOptions,
    handleGetVehicleTryAgain,
    handleGetWorkplacesTryAgain,
    isLoadLoading,
    transportKindOptions,
    transportKindLiterals,
  } = useLoadForm({
    setIsSelectLoading,
    setIsLinesSelectLoading,
    setAffreightmentLines,
    setWorkplace,
    setModel,
    setTransportType,
    setTransportTypeValue,
    setVehicleCode,
    setBrand,
    setCapacity,
    setConsumption,
    setIsLinesSelectDisabled,
    edit,
    getLinesOfWorkplace,
  });

  const {
    isFormValid,
    createLine,
    editLine,
    isSubmitting,
  } = useFormSubmit({
    model,
    transportType,
    vehicleCode,
    brand,
    capacity,
    consumption,
    errors,
    affreightmentLines,
  });

  const isLoading = isLoadLoading || isSubmitting;

  return {
    model,
    transportType,
    transportTypeValue,
    vehicleCode,
    brand,
    capacity,
    consumption,
    workplace,
    affreightmentLines,
    isLoading,
    isSelectLoading,
    isLinesSelectLoading,
    isLinesSelectDisabled,
    apiVehicleFetched,
    apiWorkplaceFetched,
    doesListWorkplacesExists,
    getErrorMessageByFieldName,
    animatedComponents,
    isFormValid,
    workplacesOptions,
    linesOptions,
    transportKindOptions,
    transportKindLiterals,
    handleGetVehicleTryAgain,
    handleGetWorkplacesTryAgain,
    handleModelChange,
    handleVehicleCodeChange,
    handleBrandChange,
    handleCapacityChange,
    handleConsumptionChange,
    handleLocTrabChange,
    handleLinesChange,
    createLine,
    setTransportType,
    editLine,
  };
}
